import ModalOpener from '../../components/modal/modal-opener'
import ProductModal from './product-modal'

class ProductModalOpener extends ModalOpener {
  showModal(): void {
    if (!this.dataset.modal) {
      return
    }

    const modal = document.querySelector<ProductModal>(this.dataset.modal)

    if (!modal) {
      return
    }

    modal.openAndShowMediaById(this.dataset.mediaId)
  }
}

export default ProductModalOpener
